import ButtonDropdown from "components/common/button-dropdown/ButtonDropdown";
import Button from "components/common/button/Button";
import { useTranslation } from "react-i18next";
import { appLanguages } from "config/app-constants";
import {useEffect, useState} from "react";

type LanguageType = typeof appLanguages[0];

const getImgTag = (l: LanguageType) => {
    return (
        <img src={l.flag} title={l.name} alt={l.name} />
    );
}

const LanguageSwitcher = () => {
    const [t, i18next] = useTranslation();
    const [language, setLanguage] = useState<LanguageType>({...appLanguages.find(l => l.code === i18next.resolvedLanguage) || appLanguages[0]});

    useEffect(() => {
        console.log('lange changed')
        document.getElementsByTagName("html")[0].setAttribute("lang", language.code);
    }, [language])

    const button = <Button className="my-auto h-full link" title={t('button.language-switch')}>
        {getImgTag(language)}
    </Button>;

    const changeLanguage = (language: LanguageType) => {
        i18next.changeLanguage(language.code);
        setLanguage({...language});
    }

    return (
        <ButtonDropdown button={getImgTag(language)} className="p-0">
            <ul>
                {appLanguages.filter(c => c.code !== language.code)
                    .map(l => {
                        return <li key={l.code}>
                            <Button title={l.name} className="link px-5" onClick={() => changeLanguage(l)}>
                                {getImgTag(l)}
                            </Button>
                        </li>
                    })}
            </ul>
        </ButtonDropdown>
    );
}
export default LanguageSwitcher;
